/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useState, Suspense } from "react";
import { ToastContainer } from "react-toastify";
import View from "@vkontakte/vkui/dist/components/View/View";
import "@vkontakte/vkui/dist/vkui.css";
import { connect, Provider, useDispatch } from "react-redux";
import { ConfigProvider, ScreenSpinner } from "@vkontakte/vkui";
import Div from "@vkontakte/vkui/dist/components/Div/Div";
import axios from "axios";
import LogInPanel from "./panels/LogInPanel";
import store from "./redux/store";
import EqueuesPanel from "./panels/EqueuesPanel";
import SelectedEqueuePanel from "./panels/SelectedEqueuePanel/SelectedEqueuePanel";
import { Eruda } from './components';

import {
  panels,
  R_N_M_FIRST_STEP_ADDRESS,
  SELECT_EQUEUE_ADDRESS,
} from "./variables";
import UserInfoPanel from "./panels/UserInfoPanel";
import RegionAndMedicalOrganisation from "./panels/RegionAndMedicalOrganisation/RegionAndMedicalOrganisation";
import RegionSelector from "./panels/RegionSelector/RegionSelector";
import RegionSearchPanel from "./panels/RegionSearchPanel/RegionSearchPanel";
import MedicalOrganisationSelector from "./panels/MedicalOrganisationSelector/MedcalOrganisationSelector";
import DoctorPanel from "./panels/DoctorPanel/DoctorPanel";
import DoctorSpecialitySelector from "./panels/DoctorSpecialitySelector/DoctorSpecialitySelector";
import DoctorNameSelector from "./panels/DoctorNameSelector/DoctorNameSelector";
import ChooseDatePanel from "./panels/ChooseDatePanel";
import ChooseTimePanel from "./panels/ChooseTimePanel";
import ConfirmPanel from "./panels/ConfirmPanel/ConfirmPanel";
import OMSPanel from "./panels/OMSPanel/OMSPanel";
import ErrorPanel from "./panels/ErrorPanel/ErrorPanel";
import MoscowRegionDoctorPanel from "./panels/MoscowRegionDoctorPanel";
import { SET_API_BASE_AUTH_ADDRESS } from "./redux/actions/types";
import "./App.scss";
import { setPreviousPanel } from "./redux/actions/panelsActions";
import RemoveOldRecordError from "./panels/ErrorPanel/RemoveOldRecordError";
import ErrorBoundary from "./ErrorBoundary";
import Api from "src/api";
import vkBridge from "@vkontakte/vk-bridge";
import { logout } from "./redux/actions/userActions";
import "react-toastify/dist/ReactToastify.css";
import CustomErrorPanel from "./panels/ErrorPanel/CustomErrorPanel";
import useListenAllErrors from "./hooks/useListenAllErrors";
import LogService from "./api/logService";

// console.log(Array.from(new URLFurlSearchParams(window.location.search)));

let debugModeEnabled = false;

// Enable full log scenario for client
if (
  new URLSearchParams(window.location.search).get("vk_debug_enabled") === "true"
) {
  debugModeEnabled = true;
  LogService.enableEachLogSend();
}

const App = ({
  activePanel = panels.login,
  panelsHistory,
  goBack,
  activeAlert,
}) => {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);

  const [loader, setLoader] = React.useState(true);

  const isFirst = panelsHistory.length === 1;

  const onPopState = React.useCallback(() => {
    if (!isFirst) {
      goBack();
    } else {
      dispatch(logout());
      vkBridge.send("VKWebAppClose", {
        status: "success",
        payload: { name: "closeApp" },
      });
    }
  }, [isFirst, goBack]);

  useListenAllErrors();

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [onPopState]);

  React.useEffect(() => {
    console.log("Debug 1")
    vkBridge.send(
      isFirst ? "VKWebAppEnableSwipeBack" : "VKWebAppDisableSwipeBack"
    );
  }, [isFirst]);

  React.useEffect(async () => {
    try {
      const { data } = await axios.get("/config.json");

      try {
        // Temporary solution: remove cookie before start application
        await fetch(`${data.apiBase}/shared/v1/logout`, {
          method: "POST",
          credentials: "include",
        });
      } catch (e) {
        // do nothing
      }

      if (data && Object.keys(data).length) {
        const { apiBase, metricsBase, isDev } = data;
        if (metricsBase) {
          Api.updateHealthUrl(metricsBase);
        }
        if (apiBase) {
          Api.updateBaseUrl(apiBase);
        }
        if (isDev === true) {
          debugModeEnabled = true;
        }
      }

      dispatch({
        type: SET_API_BASE_AUTH_ADDRESS,
        payload: { ...data, isTestingMode: debugModeEnabled },
      });

      try {
        await Api.instance.get(SELECT_EQUEUE_ADDRESS);
      } catch (e) {
        console.error(e);
        dispatch(logout());
      }

    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
      setLoader(false);
    }
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener("error", (event) => {
      console.log("unhandled error. redirect to login page", event);
      dispatch(logout());
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    Api.instance.on("logout", () => {
      console.log("Request failed with 401, logout initiated");
      dispatch(logout());
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      // eslint-disable-next-line react/jsx-filename-extension
      <Div style={{ marginTop: "10vh" }}>
        <ScreenSpinner />
      </Div>
    );
  }

  return (
    <Provider store={store}>
      <ToastContainer />

      {debugModeEnabled && (
        <Suspense fallback={null}>
          <Eruda />
        </Suspense>
      )}

      <ErrorBoundary>
        <ConfigProvider isWebView>
          <View
            onSwipeBack={goBack}
            history={panelsHistory}
            activePanel={activePanel}
            popout={activeAlert}
          >
            <RemoveOldRecordError id={panels.removeOldRecordError} />
            <LogInPanel id={panels.login} />
            <EqueuesPanel id={panels.equeues} />
            <SelectedEqueuePanel id={panels.selectedEqueue} />
            <UserInfoPanel id={panels.userInfo} />
            <RegionAndMedicalOrganisation
              id={panels.regionAndMedicalOrganisation}
            />
            <RegionSelector id={panels.regions} />
            <RegionSearchPanel id={panels.regionSearchPanel} />
            <MedicalOrganisationSelector
              id={panels.medicalOrganisationSelector}
            />
            <DoctorPanel id={panels.doctor} />
            <DoctorSpecialitySelector id={panels.doctorSpecialitySelector} />
            <DoctorNameSelector id={panels.doctorNameSelector} />
            <ChooseDatePanel id={panels.choseDate} />
            <ChooseTimePanel id={panels.chooseTime} />
            <ConfirmPanel id={panels.confirmPanel} />
            <OMSPanel id={panels.oms} />
            <ErrorPanel id={panels.error} />
            <CustomErrorPanel id={panels.customError} />
            <MoscowRegionDoctorPanel id={panels.moscowRegionDoctorPanel} />
          </View>
        </ConfigProvider>
      </ErrorBoundary>
    </Provider>
  );
};

const mapStateToProps = (state) => {
  return {
    activePanel: state.panels.activePanel,
    panelsHistory: state.panels.panelsHistory,
    activeAlert: state.alerts.activeAlert,
  };
};

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(setPreviousPanel()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
